module.exports = __webpack_public_path__ + "static/img/zhong18.614872b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong18.png
// module id = izU2
// module chunks = 16